import axios from './axios';
import { isEmptyObject } from './common';

export function DownloadFile(url, { params = null, method = null }) {
	return axios({
		url: url,
		method: method || 'GET',
		params: params,
		responseType: 'blob'
	}).then(res => {
		let header = res.request.getResponseHeader('Content-Disposition');
		let fileName = header.split('filename=');
		//Create a Blob from the PDF Stream
		const file = new Blob([res.data], { type: res.headers['content-type'] });
		//Build a URL from the file
		const fileURL = URL.createObjectURL(file);
		//Open the URL on new Window
		let tempLink = document.createElement('a');
		tempLink.href = fileURL;
		tempLink.setAttribute('download', fileName[1]);
		tempLink.click();
	});
}

export function ShowFile(url, { params = null, method = null }) {
	return axios({
		url: url,
		method: method || 'GET',
		params: params,
		responseType: 'blob'
	}).then(res => {
		//Create a Blob from the PDF Stream
		const file = new Blob([res.data], { type: res.headers['content-type'] });
		//Build a URL from the file
		const fileURL = URL.createObjectURL(file);
		//Open the URL on new Window
		window.open(fileURL, '_blank');
	});
}

export function UploadFile(file, url, method = null, params = null) {
	const formData = new FormData();

	formData.append('file', file);
	formData.append('contentType', file.type);

	// append dei parametri parent
	if (params)
		Object.keys(params).forEach(key => {
			formData.append(key, params[key]);
		});

	const config = {
		headers: {
			'content-type': 'multipart/form-data'
		}
	};

	return axios({
		url: url,
		method: method || 'POST',
		data: formData,
		config: config
	});
}

export function getFile(files, code, tags) {
	if (!isEmptyObject(files) && files !== '' && !isEmptyObject(tags)) {
		const tag = tags.find(t => t.code === code);
		let _files = files.filter(x => {
			let res = x.tag.find(t => {
				if (typeof t !== 'object') {
					return t === tag?.id;
				} else {
					return t?.id === tag?.id;
				}
			});

			if (res) return x;
		});
		return _files === undefined ? null : _files;
	} else return null;
}

export function findOtherFile(tagCode, files, tags) {
	let others = files.filter(x => {
		let tag = tags.find(t => t.code === tagCode);
		let res = x.tag.find(t => {
			if (typeof t !== 'object') {
				return t === tag?.id;
			} else {
				return t?.id === tag?.id;
			}
		});

		if (!res) return x;
	});
	return others;
}

export function findFiles(tagCode, files, tags) {
	let others = files.filter(x => {
		let tag = tags.find(t => t.code === tagCode);
		let res = x.tag.find(t => {
			if (typeof t !== 'object') {
				return t === tag?.id;
			} else {
				return t?.id === tag?.id;
			}
		});

		if (res) return x;
	});
	return others;
}

export function checkMandatory(tagCode, files, tags) {
	let others = files.filter(x => {
		let tag = tags.find(t => t.code === tagCode);
		let required = Boolean(tag?.mandatoryRequired)
			? parseInt(tag?.mandatoryRequired)
			: null;
		let loaded = Boolean(tag?.mandatoryLoaded)
			? parseInt(tag?.mandatoryLoaded)
			: null;
		var mandatory = true;
		if (required !== null && required !== 0) {
			//sicuramente non opzionale
			if (loaded === 0 || loaded === null) {
				mandatory = false;
			} else {
				if (loaded < required) {
					mandatory = false;
				}
			}
		}
		// console.log(
		// 	'tag ',
		// 	tag,
		// 	'required ',
		// 	required,
		// 	'loaded ',
		// 	loaded,
		// 	'mandatory ',
		// 	mandatory
		// );
		let res = x.tag.find(t => {
			if (typeof t !== 'object') {
				return t === tag?.id;
			} else {
				return t?.id === tag?.id;
			}
		});

		if (res && mandatory) return x;
	});
	// console.log('empty ', isEmptyObject(others));
	return others;
}

export function filterFileByTag(files,tagsMap,tag) {
	let tagId = tagsMap.get(tag)?.id;

	let nFiles = files?.filter(x => {
		let fileTagId;
		if (typeof x?.tag[0] === 'number') fileTagId = x?.tag[0];
		else fileTagId = x?.tag[0]?.id;

		if (fileTagId === tagId) return x;

		return null;
	});

	return nFiles?.length || 0;
}
